export default __webpack_public_path__ + "ff0fc64da2c933a2c9485346cad6646e.svg";